export enum Originate {
  AGGERG8 = 'aggreg8',
  SZAMLAZZHU = 'szamlazzhu',
  ADRIANA = 'adriana',
  EMPTY = '',
}
